import { render } from "./MainTemplate.vue?vue&type=template&id=2de37ec2"
const script = {}

import "./MainTemplate.vue?vue&type=style&index=0&id=2de37ec2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__